import { render, staticRenderFns } from "./AuditPopup.vue?vue&type=template&id=638a54bb&scoped=true"
import script from "./AuditPopup.vue?vue&type=script&lang=js"
export * from "./AuditPopup.vue?vue&type=script&lang=js"
import style0 from "./AuditPopup.vue?vue&type=style&index=0&id=638a54bb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "638a54bb",
  null
  
)

export default component.exports